import { ThemeIcon } from '@mantine/core';

export default ThemeIcon.extend({
  defaultProps: {
    variant: 'transparent',
    color: 'gray.6',
  },
});
